import mixpanel from "mixpanel-browser";
import env from '../constants/env'

mixpanel.init(`${env.MIXPANEL_PROJECT_TOKEN}`, {
    persistence: 'localStorage',
    track_pageview: true,
    autotrack: false,
});

export default mixpanel;
